import "./App.css";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";

import LoginForm from "./Components/LoginForm";
import Nav from "./Components/Shared/Nav";
import Logout from "./Components/Shared/Logout";
import Dashboard from "./Components/Dashboard";
import ChangePassword from "./Components/ChangePassword";
import ProtectedRoute from "./Utils/ProtectedRoute";

function App() {
  return (
    <div className="App">
      <Router>
        <Layout />
      </Router>
    </div>
  );
}

function Layout() {
  const location = useLocation();
  const hideNavOn = ["/"];

  return (
    <>
      {!hideNavOn.includes(location.pathname) && <Nav />}
      <Routes>
        <Route path="/" element={<LoginForm />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Routes>
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="ChangePassword" element={<ChangePassword />} />
                <Route path="Logout" element={<Logout />} />
              </Routes>
            </ProtectedRoute>
          }
        />
      </Routes>
    </>
  );
}

export default App;
